module.exports = __webpack_public_path__ + "img/patient-info-mobile-en.aac5e303.jpg";